module.exports = __webpack_public_path__ + "static/media/close.a35b9619.svg";